import { useContext } from "react";
import { Outlet } from "react-router";
import AdminSidebar from "../pages/Admin/components/AdminSidebar";
import LecturerSidebar from "../pages/Lecturer/components/LecturerSidebar";
import NoPermission from "../components/ui/NoPermission";
import { AuthContext } from "../contexts/authContext";
import { AnalyticsProvider } from "../contexts/AnalyticsContext";
import { CourseProvider } from "../contexts/CourseContext";

const AdminOrLecturerLayout = () => {
  const { user } = useContext(AuthContext);

  if (!user || (!user.is_admin && user.user_type !== "lecturer")) {
    return <NoPermission />;
  }

  const Sidebar = user.is_admin ? AdminSidebar : LecturerSidebar;

  return (
    <AnalyticsProvider>
      <CourseProvider>
        <Sidebar>
          <Outlet />
        </Sidebar>
      </CourseProvider>
    </AnalyticsProvider>
  );
};

export default AdminOrLecturerLayout;
